import React, {PropTypes} from 'react'
import classNames from 'classnames'

import './TabPanelControlV2.scss';

class TabPanelControlV2 extends React.Component {
  
  static propTypes = {
    className: PropTypes.string,
    tabClassName: PropTypes.string,
    activeTab : PropTypes.number,
    info: PropTypes.arrayOf(PropTypes.shape({
      content: PropTypes.node.isRequired,
      onSelect: PropTypes.func.isRequired,
      additionalClassName: PropTypes.string
    })).isRequired
  }
  
  state = {
    activeTab: this.props.activeTab
  }
  
  _setActiveTab = (activeTab) => {
    if (this.state.activeTab !== activeTab) {
      this.setState({activeTab: activeTab});
      
      if (this.props.info[activeTab].onSelect) {
        this.props.info[activeTab].onSelect();
      };
    };
  }
  
  _renderTabs = () => {
    var tabsCount = this.props.info.length;
    var tabs = [];
    
    if (this.props.info.length > 4) {
      tabsCount = 4;
    }
    
    for (var i = 0; i < tabsCount; i++) {
      var componentClass = classNames(
        'Tabs__tab',
        (this.state.activeTab === i ? 'Tabs__tab--active' : ''),
        this.props.tabClassName,
        this.props.info[i].additionalClassName
      );
      
      tabs.push(
        <div className={componentClass}
             key={'tab_' + i}
             onClick={this._setActiveTab.bind(this, i)}>{this.props.info[i].content}</div>
      )
    };
    
    return tabs;
  }
  
  componentWillMount() {
    if (this.state.activeTab && this.props.info[this.state.activeTab].onSelect) {
      // this.props.info[this.state.activeTab].onSelect();
    }
  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.activeTab !== undefined) {
      this.setState({activeTab: nextProps.activeTab});
    }
  }
  
  render() {
    var tabsCount = this.props.info.length;
    
    if (this.props.info.length > 4) {
      tabsCount = 4;
    }
    
    const tabs = this._renderTabs();
    const componentClass = classNames (
      'Tabs',
      'Tabs--' + tabsCount,
      this.props.className
    )
    
    return (
      <div className={componentClass}>
        {tabs}
      </div>
    );
  }
}

export default TabPanelControlV2;



// WEBPACK FOOTER //
// ./client/components/TabPanelControlV2/TabPanelControlV2.js